import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import StatsDataService from "../services/StatsService";

const initialState = {
  stats: [],
  error: null,
  success: null,
  loading: false,
  retrieveStats: '',
}

export const retrieveStats = createAsyncThunk(
  "stats/retrieve",
  async (thunkAPI) => {
    const response = await StatsDataService.getAll();
    let { data } = response.data;
    return data;
  }
);

const statsSlice = createSlice({
  name: "stats",
  initialState,
  reducers: {
    selectAsset: (state, action) => {
      state.selectedStats = action.payload
    },
    setStats: (state, action) => {
      state.stats = action.payload ?? []
      state.loading = false
      state.retrieveStats = 'fetch'
    },
  },
  extraReducers: {
    [retrieveStats.pending]: (state, action) => {
      state.loading = true
      state.retrieveStats = ''
    },
    [retrieveStats.fulfilled]: (state, action) => {
      state.loading = false
      state.stats = action.payload;
      state.retrieveStats = 'fetch'
    },
    [retrieveStats.rejected]: (state, action) => {
      state.loading = false
      state.retrieveStats = 'fetch failed'
    },
  },
});

const { reducer } = statsSlice;
export const { selectStat, setStats } = statsSlice.actions
export default reducer;